<template>
    <div class="signer-panel-page">
        <header class="signer-panel-header">
            <img class="signer-panel-logo" alt="R2 Soft" src="@/assets/img/logo-pb.png">
            <nav class="signer-panel-menu" aria-label="Menu principal">
                <a v-if="!isAuthenticated" href="#" class="signer-panel-menu-item active" @click.prevent>
                    <i class="icon-home2"></i> Painel
                </a>
                <a v-if="isAuthenticated && !isAdministrationPendingSigner" href="#documents" :class="['signer-panel-menu-item', {active: activeFilter === 'all'}]" @click.prevent="setActiveFilter('all')">
                    <i class="icon-documents"></i> Todos
                </a>
                <a v-if="isAuthenticated" href="#documents" :class="['signer-panel-menu-item', {active: activeFilter === pendingFilterStatus}]" @click.prevent="setActiveFilter(pendingFilterStatus)">
                    <i class="icon-clock1"></i> {{ pendingFilterLabel }}
                </a>
                <a v-if="isAuthenticated" href="#documents" :class="['signer-panel-menu-item', {active: activeFilter === 'signed'}]" @click.prevent="setActiveFilter('signed')">
                    <i class="icon-check"></i> Assinados
                </a>
                <a v-if="isAuthenticated" href="#" class="signer-panel-menu-item" @click.prevent="logout">
                    <i class="icon-log-out"></i> Sair
                </a>
            </nav>
        </header>

        <main :class="['signer-panel-container', {'signer-panel-container-login': !isAuthenticated}]">
            <div v-if="isAuthenticated" class="signer-panel-title">
                <li class="firstt">Painel do Signatário</li>
                <p>Acompanhe seus documentos para assinatura.</p>
            </div>

            <section v-if="!isAuthenticated" class="signer-panel-login-shell">
                <div class="signer-panel-login-intro">
                    <li class="firstt">Painel do Signatário</li>
                    <p>Acesse seus documentos pendentes e assinados de forma simples.</p>
                </div>

                <div class="card signer-panel-login">
                <div class="card-header">
                    <div class="card-title">Entrar</div>
                    <div class="card-sub-title">Informe o e-mail e CPF usados no documento.</div>
                </div>

                <form class="card-body" @submit.prevent="login">
                    <div class="form-group">
                        <label for="signer-email">E-mail</label>
                        <input
                                id="signer-email"
                                v-model.trim="loginForm.email"
                                type="email"
                                class="form-control"
                                required
                                autocomplete="email"
                                placeholder="seu@email.com">
                    </div>

                    <div class="form-group">
                        <label for="signer-documentation">CPF</label>
                        <input
                                id="signer-documentation"
                                v-model.trim="loginForm.cpf_cnpj"
                                type="text"
                                class="form-control"
                                required
                                inputmode="numeric"
                                autocomplete="off"
                                placeholder="Digite apenas números ou com máscara">
                    </div>

                    <div v-if="errorMessage" class="alert alert-danger" role="alert">
                        {{ errorMessage }}
                    </div>

                    <button class="btn btn-primary btn-block signer-panel-primary" type="submit" :disabled="isLoading">
                        {{ isLoading ? 'Entrando...' : 'Acessar painel' }}
                    </button>
                </form>
                </div>
            </section>

            <section v-else id="documents" class="card signer-panel-documents">
                <div class="card-header signer-panel-toolbar">
                    <div class="signer-panel-user">
                        <div class="card-title">Meus documentos</div>
                        <div class="card-sub-title">{{ signer.name }} - {{ signer.email }}</div>
                    </div>
                    <button class="btn btn-custom bg-btn" type="button" @click="logout" :disabled="isLoading">
                        <i class="icon-log-out"></i> Sair
                    </button>
                </div>

                <div class="card-body">
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">
                        {{ errorMessage }}
                    </div>

                    <div v-if="isLoading" class="signer-panel-empty">
                        Carregando documentos...
                    </div>

                    <div v-else-if="!documents.length" class="signer-panel-empty">
                        Nenhum documento encontrado para seus dados.
                    </div>

                    <div v-else class="signer-panel-list">
                        <article v-for="document in documents" :key="document.id" class="task-block signer-panel-document">
                            <div class="task-details signer-panel-document-main">
                                <span :class="['signer-panel-status', signatureStatusClass(document)]">
                                    {{ signatureStatusLabel(document) }}
                                </span>
                                <div class="task-name">{{ document.name || 'Documento sem nome' }}</div>
                                <div class="task-desc">{{ document.company_name || 'Empresa não informada' }}</div>
                                <div class="task-types signer-panel-meta">
                                    <span>Função: {{ signAsLabel(document.sign_as) }}</span>
                                    <span>Expiração: {{ formatDate(document.deadline_at) }}</span>
                                    <span v-if="document.signed_at">Assinado em: {{ formatDate(document.signed_at) }}</span>
                                </div>
                            </div>

                            <div class="signer-panel-actions">
                                <button
                                        v-if="canSignDocument(document)"
                                        class="btn btn-primary btn-sm"
                                        type="button"
                                        @click="openSignature(document)">
                                    Assinar
                                </button>
                                <button
                                        v-if="document.id"
                                        class="btn btn-custom bg-btn btn-sm"
                                        type="button"
                                        :disabled="openingOriginalDocumentId === document.id"
                                        @click="openOriginalDocument(document)">
                                    {{ openingOriginalDocumentId === document.id ? 'Abrindo...' : 'Documento' }}
                                </button>
                                <button
                                        v-if="document.status_of_signature === 'signed' && document.signed_file_url"
                                        class="btn btn-custom bg-btn btn-sm"
                                        type="button"
                                        :disabled="openingSignedDocumentId === document.id"
                                        @click="openSignedDocument(document)">
                                    {{ openingSignedDocumentId === document.id ? 'Abrindo...' : 'Documento Assinado' }}
                                </button>
                            </div>
                        </article>
                    </div>

                    <div v-if="pagination.total > 0" class="signer-panel-pagination-wrap">
                        <div class="signer-panel-pagination-info">
                            Exibindo {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} documentos
                        </div>
                        <div v-if="pagination.last_page > 1" class="signer-panel-pagination">
                            <button class="signer-panel-page-button" type="button" :disabled="pagination.current_page <= 1 || isLoading" @click="changePage(pagination.current_page - 1)">
                                Anterior
                            </button>
                            <button
                                    v-for="page in paginationPages"
                                    :key="page"
                                    :class="['signer-panel-page-button', {active: page === pagination.current_page}]"
                                    type="button"
                                    :disabled="isLoading || page === pagination.current_page"
                                    @click="changePage(page)">
                                {{ page }}
                            </button>
                            <button class="signer-panel-page-button" type="button" :disabled="pagination.current_page >= pagination.last_page || isLoading" @click="changePage(pagination.current_page + 1)">
                                Próxima
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import {http} from '@/services/config';

const TOKEN_KEY = 'signer_panel_access_token';
const SIGNER_KEY = 'signer_panel_signer';

export default {
    name: 'SignerPanelComponent',
    data() {
        return {
            isLoading: false,
            errorMessage: '',
            loginForm: {
                email: '',
                cpf_cnpj: '',
            },
            accessToken: localStorage.getItem(TOKEN_KEY),
            signer: {},
            documents: [],
            activeFilter: 'all',
            openingOriginalDocumentId: null,
            openingSignedDocumentId: null,
            pagination: {
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
                total: 0,
            },
        }
    },
    computed: {
        isAuthenticated() {
            return !!this.accessToken;
        },
        paginationPages() {
            const currentPage = this.pagination.current_page || 1;
            const lastPage = this.pagination.last_page || 1;
            const startPage = Math.max(currentPage - 2, 1);
            const endPage = Math.min(startPage + 4, lastPage);
            const firstPage = Math.max(endPage - 4, 1);
            const pages = [];

            for (let page = firstPage; page <= endPage; page++) {
                pages.push(page);
            }

            return pages;
        },
        pendingFilterStatus() {
            return this.signer?.is_administration_pending_signer ? 'pending_adm' : 'pending';
        },
        pendingFilterLabel() {
            return this.signer?.is_administration_pending_signer ? 'Pendentes P/ Adm' : 'Pendentes';
        },
        isAdministrationPendingSigner() {
            return !!this.signer?.is_administration_pending_signer;
        },
    },
    mounted() {
        this.loadSession();
    },
    methods: {
        loadSession() {
            const storedSigner = localStorage.getItem(SIGNER_KEY);
            if (!this.accessToken) return;

            if (storedSigner) {
                try {
                    this.signer = JSON.parse(storedSigner);
                } catch (err) {
                    if (err) this.signer = {};
                }
            }
            this.refreshSignerSession();
        },
        refreshSignerSession() {
            http.get('v1/painel-signatario/me', {
                headers: this.authHeaders(),
            }).then((resp) => {
                this.signer = resp.data?.signer || this.signer;
                localStorage.setItem(SIGNER_KEY, JSON.stringify(this.signer));
                this.activeFilter = this.isAdministrationPendingSigner ? 'pending_adm' : 'all';
            }).catch((err) => {
                if (err?.response?.status === 401) {
                    this.clearSession();
                    this.errorMessage = 'Sua sessão expirou. Acesse novamente.';
                    return;
                }
            }).finally(() => {
                if (this.isAuthenticated) this.fetchDocuments();
            });
        },
        authHeaders() {
            return {
                Authorization: `Bearer ${this.accessToken}`,
            };
        },
        login() {
            this.isLoading = true;
            this.errorMessage = '';

            http.post('v1/painel-signatario/login', this.loginForm).then((resp) => {
                localStorage.setItem(TOKEN_KEY, resp.data.access_token);
                localStorage.setItem(SIGNER_KEY, JSON.stringify(resp.data.signer || {}));
                this.accessToken = resp.data.access_token;
                this.signer = resp.data.signer || {};
                this.activeFilter = this.isAdministrationPendingSigner ? 'pending_adm' : 'all';
                this.fetchDocuments();
            }).catch((err) => {
                this.errorMessage = err?.response?.data?.message || 'Não foi possível acessar o painel.';
                this.isLoading = false;
            });
        },
        fetchDocuments(page = 1) {
            this.isLoading = true;
            this.errorMessage = '';

            http.get('v1/painel-signatario/documentos', {
                headers: this.authHeaders(),
                params: {page, per_page: 15, status: this.activeFilter},
            }).then((resp) => {
                this.documents = resp.data?.data || [];
                this.pagination = {
                    current_page: resp.data?.current_page || 1,
                    last_page: resp.data?.last_page || 1,
                    from: resp.data?.from || 0,
                    to: resp.data?.to || 0,
                    total: resp.data?.total || 0,
                };
                this.isLoading = false;
            }).catch((err) => {
                if (err?.response?.status === 401) {
                    this.clearSession();
                    this.errorMessage = 'Sua sessão expirou. Acesse novamente.';
                } else {
                    this.errorMessage = err?.response?.data?.message || 'Não foi possível carregar os documentos.';
                }
                this.isLoading = false;
            });
        },
        logout() {
            this.isLoading = true;
            http.post('v1/painel-signatario/logout', {}, {headers: this.authHeaders()}).finally(() => {
                this.clearSession();
                this.isLoading = false;
            });
        },
        clearSession() {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(SIGNER_KEY);
            this.accessToken = null;
            this.signer = {};
            this.documents = [];
            this.activeFilter = 'all';
            this.pagination = {current_page: 1, last_page: 1, from: 0, to: 0, total: 0};
        },
        setActiveFilter(filter) {
            if (this.activeFilter === filter) return;

            this.activeFilter = filter;
            this.fetchDocuments(1);
        },
        changePage(page) {
            if (page < 1 || page > this.pagination.last_page || page === this.pagination.current_page) return;

            this.fetchDocuments(page);
        },
        openUrl(url) {
            window.open(url, '_blank');
        },
        openOriginalDocument(document) {
            this.errorMessage = '';
            this.openingOriginalDocumentId = document.id;
            const newTab = window.open('', '_blank');

            http.get(`v1/painel-signatario/documentos/${document.id}/original`, {
                headers: this.authHeaders(),
            }).then((resp) => {
                const originalFileUrl = resp.data?.original_file_url;

                if (!originalFileUrl) {
                    if (newTab) newTab.close();
                    this.errorMessage = 'Não foi possível abrir o documento original.';
                    return;
                }

                document.original_file_url = originalFileUrl;
                if (newTab) {
                    newTab.location = originalFileUrl;
                } else {
                    this.openUrl(originalFileUrl);
                }
            }).catch((err) => {
                if (newTab) newTab.close();
                this.errorMessage = err?.response?.data?.message || 'Não foi possível atualizar o link do documento original.';
            }).finally(() => {
                this.openingOriginalDocumentId = null;
            });
        },
        openSignedDocument(document) {
            this.errorMessage = '';
            this.openingSignedDocumentId = document.id;
            const newTab = window.open('', '_blank');

            http.get(`v1/painel-signatario/documentos/${document.id}/assinado`, {
                headers: this.authHeaders(),
            }).then((resp) => {
                const signedFileUrl = resp.data?.signed_file_url;

                if (!signedFileUrl) {
                    if (newTab) newTab.close();
                    this.errorMessage = 'Não foi possível abrir o documento assinado.';
                    return;
                }

                document.signed_file_url = signedFileUrl;
                if (newTab) {
                    newTab.location = signedFileUrl;
                } else {
                    this.openUrl(signedFileUrl);
                }
            }).catch((err) => {
                if (newTab) newTab.close();
                this.errorMessage = err?.response?.data?.message || 'Não foi possível atualizar o link do documento assinado.';
            }).finally(() => {
                this.openingSignedDocumentId = null;
            });
        },
        openSignature(document) {
            const host = process.env.VUE_APP_CLICKSIGN_SIGN_URL || 'https://app.clicksign.com/sign';
            this.openUrl(`${host.replace(/\/$/, '')}/${document.request_signature_key}`);
        },
        signatureStatusLabel(document) {
            if (document.status === 'expired') return 'Expirado';
            if (document.status_of_signature === 'signed') return 'Assinado';
            if (document.status === 'canceled') return 'Cancelado';
            if (document.status === 'closed') return 'Finalizado';
            return 'Pendente';
        },
        signatureStatusClass(document) {
            if (document.status === 'expired') return 'is-expired';
            if (document.status_of_signature === 'signed') return 'is-signed';
            if (document.status === 'canceled') return 'is-canceled';
            return 'is-pending';
        },
        canSignDocument(document) {
            return document.status !== 'expired'
                && document.status_of_signature !== 'signed'
                && !!document.request_signature_key;
        },
        signAsLabel(signAs) {
            const labels = {
                sign: 'Assinar',
                buyer: 'Comprador',
                seller: 'Vendedor',
                witness: 'Testemunha',
                broker: 'Corretor',
            };
            return labels[signAs] || signAs || 'Não informada';
        },
        formatDate(date) {
            if (!date) return 'Não informada';
            return new Date(date).toLocaleDateString('pt-BR');
        },
    },
}
</script>

<style scoped>
.signer-panel-page {
    min-height: 100vh;
    background: #f2f4f9;
}

.signer-panel-header {
    align-items: center;
    background: #0e5e4e;
    border-bottom: 1px solid #e6ebf1;
    display: flex;
    gap: 28px;
    height: 70px;
    padding: 0 30px;
}

.signer-panel-container {
    margin: 0 auto;
    max-width: 1180px;
    padding: 20px 24px 40px;
}

.signer-panel-container-login {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 70px);
    padding-bottom: 60px;
    padding-top: 44px;
}

.signer-panel-logo {
    max-height: 42px;
    max-width: 190px;
}

.signer-panel-menu {
    align-items: stretch;
    display: flex;
    height: 100%;
}

.signer-panel-menu-item {
    align-items: center;
    border-bottom: 3px solid transparent;
    color: rgba(255, 255, 255, .82);
    display: flex;
    font-size: 14px;
    gap: 8px;
    padding: 0 16px;
    text-decoration: none;
}

.signer-panel-menu-item:hover,
.signer-panel-menu-item.active {
    background: rgba(255, 255, 255, .08);
    border-bottom-color: #fff;
    color: #fff;
    text-decoration: none;
}

.signer-panel-title {
    margin-bottom: 12px;
}

.firstt {
    align-items: center;
    background: transparent;
    border-radius: 0;
    display: flex;
    flex-wrap: wrap;
    font-size: 1.5rem;
    list-style: none;
    margin: 0;
    padding: 1rem 0 0.5rem 0;
}

.signer-panel-title p {
    color: #8796af;
    margin: 0 0 10px;
}

.btn-custom {
    border: none;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    text-decoration: none;
    transition-duration: .4s;
}

.bg-btn {
    background-color: #fff !important;
    border: 1px solid #0e5e4e;
    color: #000 !important;
}

.bg-btn:hover,
.bg-btn:focus {
    background-color: #0e5e4e !important;
    color: #fff !important;
}

.signer-panel-login {
    margin: 0;
    max-width: none;
    width: 100%;
}

.signer-panel-login-shell {
    display: grid;
    gap: 24px;
    max-width: 540px;
    width: 100%;
}

.signer-panel-login-intro {
    text-align: center;
}

.signer-panel-login-intro .firstt {
    justify-content: center;
    padding-top: 0;
}

.signer-panel-login-intro p {
    color: #8796af;
    font-size: 14px;
    margin: 0 auto;
    max-width: 420px;
}

.signer-panel-login .card-body {
    padding: 1.5rem;
}

.signer-panel-login .card-header {
    text-align: center;
}

.signer-panel-documents {
    margin-bottom: 20px;
}

.signer-panel-primary {
    font-weight: 700;
}

.signer-panel-toolbar {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.signer-panel-toolbar .card-title {
    margin-bottom: 3px;
}

.signer-panel-user {
    min-width: 0;
}

.signer-panel-list {
    display: grid;
    gap: 10px;
}

.signer-panel-document {
    align-items: center;
    background: #fff;
    border: 1px solid #e6ebf1;
    border-radius: 3px;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 15px;
}

.signer-panel-document-main {
    min-width: 0;
}

.signer-panel-document .task-name {
    color: #2e323c;
    font-size: 15px;
    font-weight: 600;
    margin-top: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.signer-panel-document .task-desc {
    color: #8796af;
    font-size: 13px;
    margin-top: 2px;
}

.signer-panel-meta {
    color: #5f6b7a;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    gap: 6px 14px;
    margin-top: 8px;
}

.signer-panel-status {
    border-radius: 1em;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    min-width: 80px;
    padding: 2px 8px;
    justify-content: center;
}

.signer-panel-status.is-signed {
    background: #3FBF3F;
    color: #EBF1EB;
}

.signer-panel-status.is-pending {
    background: #fb7f12;
    color: #EBF1EB;
}

.signer-panel-status.is-expired {
    background: #e0bb47;
    color: #EBF1EB;
}

.signer-panel-status.is-canceled {
    background: #f34646;
    color: #EBF1EB;
}

.signer-panel-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
}

.signer-panel-empty {
    background: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 3px;
    color: #6b7280;
    padding: 28px;
    text-align: center;
}

.signer-panel-pagination-wrap {
    align-items: center;
    border-top: 1px solid #e6ebf1;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    margin-top: 18px;
    padding-top: 16px;
}

.signer-panel-pagination-info {
    color: #8796af;
    font-size: 13px;
}

.signer-panel-pagination {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
}

.signer-panel-page-button {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 3px;
    color: #2e323c;
    min-width: 36px;
    padding: 7px 10px;
    transition: .2s;
}

.signer-panel-page-button:hover:not(:disabled),
.signer-panel-page-button.active {
    background: #0e5e4e;
    border-color: #0e5e4e;
    color: #fff;
}

.signer-panel-page-button:disabled {
    cursor: not-allowed;
    opacity: .55;
}

@media (max-width: 860px) {
    .signer-panel-header {
        align-items: center;
        flex-direction: column;
        gap: 8px;
        height: 98px;
        justify-content: center;
        padding: 0 16px;
    }

    .signer-panel-menu {
        height: auto;
        max-width: 100%;
        overflow-x: auto;
        width: 100%;
    }

    .signer-panel-menu-item {
        flex: 0 0 auto;
        padding: 6px 10px;
    }

    .signer-panel-container {
        padding: 14px 12px 28px;
    }

    .signer-panel-toolbar,
    .signer-panel-document {
        align-items: stretch;
        flex-direction: column;
    }

    .signer-panel-actions {
        justify-content: flex-start;
    }

    .signer-panel-document .task-name {
        white-space: normal;
    }

    .signer-panel-pagination-wrap {
        align-items: stretch;
        flex-direction: column;
    }

    .signer-panel-pagination {
        justify-content: flex-start;
    }
}
</style>
